import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5772959d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "experience" }
const _hoisted_2 = { class: "experience__icon" }
const _hoisted_3 = { class: "experience__wrapper" }
const _hoisted_4 = { class: "experience__header" }
const _hoisted_5 = { class: "experience__header title" }
const _hoisted_6 = { class: "actions" }
const _hoisted_7 = { class: "experience__header company" }
const _hoisted_8 = { class: "experience__header__subtitle" }
const _hoisted_9 = {
  key: 0,
  class: "experience__header location"
}
const _hoisted_10 = { class: "experience__header periode" }
const _hoisted_11 = { class: "experience__description" }
const _hoisted_12 = ["innerHTML"]

import {FormatHelper} from '@/profile-creation-wizard/common/helpers/FormatHelper';
    import ReadMore from '@/profile-creation-wizard/common/ui/ReadMore.vue';
    import {useTranslation} from '@malt/vue3-use';
    import {computed} from 'vue';
    import {object} from 'vue-types';
    import {Experience} from '../../../domain/experience/Experience';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'Experience',
  props: {
        experience: object<Experience>().isRequired,
    },
  setup(__props) {

const props = __props;

    const {msg} = useTranslation();

    

    const formattedAddress = computed(() => props.experience.location.formattedAddress);
    const formattedDescription = computed(() => FormatHelper.textToHtmlFormattedText(props.experience.description));
    const formattedStartDate = computed(() => FormatHelper.dateToSimpleDateString(props.experience.startDate));
    const formattedEndDate = computed(() => {
        if (props.experience.isCurrentJob === true) {
            return msg('profile.xp.reco.humanize.time.today');
        }

        return FormatHelper.dateToSimpleDateString(props.experience.endDate);
    });

    const readMoreLabel = msg('jstext.readmore.label.readmore');

return (_ctx: any,_cache: any) => {
  const _component_joy_icon = _resolveComponent("joy-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_joy_icon, {
        name: "company-placeholder",
        size: "large"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_5, [
            _createTextVNode(_toDisplayString(props.experience.title) + " ", 1),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_joy_icon, {
                class: "action",
                name: "trash",
                color: "red"
              }),
              _createVNode(_component_joy_icon, {
                class: "action",
                name: "pen"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_7, _toDisplayString(props.experience.company), 1),
          _createElementVNode("div", _hoisted_8, [
            (formattedAddress.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_joy_icon, {
                    name: "location",
                    color: "grey"
                  }),
                  _createTextVNode(" " + _toDisplayString(formattedAddress.value), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_joy_icon, {
                name: "calendar",
                color: "grey"
              }),
              _createTextVNode(" " + _toDisplayString(formattedStartDate.value) + " - " + _toDisplayString(formattedEndDate.value), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(ReadMore, {
          "max-height": 100,
          "view-more-label": _unref(readMoreLabel)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", { innerHTML: formattedDescription.value }, null, 8, _hoisted_12)
          ]),
          _: 1
        }, 8, ["view-more-label"])
      ])
    ])
  ]))
}
}

})